var _title, _desc, _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgModifyTripWithNoPet = function SvgModifyTripWithNoPet(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 317 200",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Illustrations/Heros/ Early Check In")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 230 325 230 325 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Illustrations/Heros/-Early-Check-In",
    transform: "translate(-4.000000, -13.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Early-Check-In"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.16524,16.0377647 C127.595135,30.0555882 168.282427,41.2687647 46.2191979,45.4750588 C-26.4724688,47.9793529 2.66242708,199.213824 74.2788854,199.669765 C149.795344,200.150059 183.778156,200.940176 201.665344,200.491 C290.348365,198.266765 311.393469,149.205059 319.812323,105.751294 C327.18576,67.6862941 299.352219,-0.588529412 206.16524,16.0377647",
    id: "Fill-1",
    fill: "#FFF4D0"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "not_pet_mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#FFFFFF",
    mask: "url(#not_pet_mask-2)",
    points: "157.340625 130.592647 237.294687 130.592647 237.294687 53.268 157.340625 53.268"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.845375,75.3009176 C145.845375,75.3009176 146.441208,72.3474471 153.811937,74.2469765 C158.753292,75.5200941 160.099333,82.4363294 157.994958,86.9362118 C155.784958,91.6566235 156.081521,93.0203882 156.234542,93.8632706 C157.392354,100.190976 150.724437,99.0639765 148.054021,97.8720353 C148.054021,97.8720353 149.016833,91.7540353 146.213708,91.7540353 C143.410583,91.7540353 143.722042,87.7303882 143.621833,85.5873294 C143.522979,83.4456235 144.946208,81.6732706 144.920479,79.3083294 C144.901521,77.4101529 144.901521,77.4101529 145.845375,75.3009176",
    id: "Fill-5",
    fill: "#C68053",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.345229,82.0511471 C155.234083,79.9419118 152.068042,77.4105588 149.533042,79.7308529 C149.323146,79.9419118 150.166792,80.3640294 150.800542,80.3640294 C150.800542,80.7847941 150.166792,80.7847941 149.956896,80.9972059 C149.745646,81.2069118 150.590646,81.2069118 150.166792,81.6290294 C150.288667,81.5884412 150.402417,81.5708529 150.512104,81.5627353 C150.291375,82.1282647 150.208771,82.6126176 150.208771,82.6126176 C150.208771,82.6126176 148.057,83.0347353 148.172104,79.2370294 C148.189708,78.6106176 148.13825,78.0762059 148.04075,77.6202647 C151.764708,77.6216176 156.576063,77.8177941 157.345229,82.0511471",
    id: "Fill-6",
    fill: "#395C6E",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.533583,79.7309882 C152.067229,77.4106941 155.234625,79.9420471 157.345771,82.0512824 C156.57525,77.8179294 151.763896,77.6217529 148.039938,77.6204 C147.544313,75.3149882 145.844833,75.0186941 145.844833,75.0186941 C145.844833,75.0186941 149.323688,70.0276941 155.445875,73.3275176 C164.50525,78.2102824 156.332854,90.6629287 156.332854,90.6629287 C151.31025,90.6965765 152.755146,85.8368118 152.755146,85.8368118 C152.755146,85.8368118 155.586708,81.4316353 153.811396,80.2924588 C151.897958,79.0653412 150.941917,80.4669882 150.512646,81.5628706 C150.402958,81.5709882 150.289208,81.5885765 150.167333,81.6291647 C150.589833,81.2070471 149.744833,81.2070471 149.956083,80.9973412 C150.167333,80.7849294 150.801083,80.7849294 150.801083,80.3641647 C150.167333,80.3641647 149.323688,79.9420471 149.533583,79.7309882",
    id: "Fill-7",
    fill: "#003449",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.780292,75.4720647 C146.780292,75.4720647 142.842375,73.5278882 144.921021,72.2006529 C144.921021,72.2006529 147.334146,74.3234176 147.705188,71.5742412 C148.053208,68.9725353 152.461021,72.5388882 151.645813,70.9410647 C150.854979,69.3946529 154.179458,70.0278294 155.586438,70.8450059 C157.690813,72.0680647 157.008313,74.8903 158.319146,75.0770059 C161.357896,75.5126529 162.567167,80.2276529 159.042271,84.7248294 C159.042271,84.7248294 158.963729,75.8644176 154.389354,75.7927118 C149.814979,75.7237118 146.780292,75.4720647 146.780292,75.4720647",
    id: "Fill-8",
    fill: "#003449",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.794437,80.8560941 C142.794437,82.3308 143.453917,83.5281529 144.270479,83.5281529 C145.084333,83.5281529 145.745167,82.3308 145.745167,80.8560941 C145.745167,79.3800353 145.084333,78.1840353 144.270479,78.1840353 C143.453917,78.1840353 142.794437,79.3800353 142.794437,80.8560941 Z",
    id: "Stroke-9",
    stroke: "#FDD058",
    strokeWidth: 0.352,
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150.566406,
    y1: 81.4315,
    x2: 145.744219,
    y2: 80.8565,
    id: "Stroke-10",
    stroke: "#FDD058",
    strokeWidth: 0.352,
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.675094,88.5899118 C149.675094,88.5899118 146.93426,91.1983824 144.855615,91.2998529 C144.855615,91.2998529 147.481344,91.6949118 147.803635,92.9653235 C148.124573,94.2357353 148.21124,93.7527353 148.21124,93.7527353 L149.675094,88.5899118 Z",
    id: "Fill-11",
    fill: "#C27342",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#FFFFFF",
    mask: "url(#not_pet_mask-2)",
    points: "133.206938 200.405088 133.206938 44.0727353 40.6794375 44.0727353 40.6794375 200.5025"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 193.071938,
    y1: 200.014629,
    x2: 193.071938,
    y2: 18.5730412,
    id: "Stroke-13",
    stroke: "#FFFFFF",
    strokeWidth: 0.741,
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 228.58049,
    y1: 197.923118,
    x2: 228.58049,
    y2: 13.0815882,
    id: "Stroke-14",
    stroke: "#FFFFFF",
    strokeWidth: 0.741,
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#FFF4D0",
    mask: "url(#not_pet_mask-2)",
    points: "166.271354 121.672706 228.363958 121.672706 228.363958 62.192 166.271354 62.192"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-16",
    stroke: "#E2E6EC",
    strokeWidth: 5.498,
    mask: "url(#not_pet_mask-2)",
    points: "166.271354 121.672706 228.363958 121.672706 228.363958 62.192 166.271354 62.192"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 196.549844,
    y1: 62.1924059,
    x2: 196.549844,
    y2: 121.673112,
    id: "Stroke-17",
    stroke: "#E2E6EC",
    strokeWidth: 5.185,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.5185208,
    y1: 54.1288765,
    x2: 21.5185208,
    y2: 165.504347,
    id: "Stroke-18",
    stroke: "#FFFFFF",
    strokeWidth: 0.741,
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.024792,125.108771 C229.024792,125.108771 221.257292,107.037535 215.487188,106.260947 L219.480625,125.330653 L226.139062,132.980182 L229.024792,125.108771 Z",
    id: "Fill-19",
    fill: "#98AAB6",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.704448,110.414612 C229.704448,110.414612 228.714552,103.162847 230.187885,103.572788 C231.661219,103.982729 234.987052,109.502729 234.263927,111.151965 C233.539448,112.802553 231.738406,115.474612 231.738406,115.474612 L230.194656,120.070553 L227.522885,116.540729 C227.522885,116.540729 228.790385,109.896435 230.006427,108.382494 C231.221115,106.868553 229.704448,110.414612 229.704448,110.414612",
    id: "Fill-20",
    fill: "#F7D5BE",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.46774,113.800347 C227.692427,114.244112 227.692427,114.908406 227.692427,115.019347 C225.58399,123.223582 225.452635,128.192935 225.472948,131.094994 C225.494615,134.191876 228.58076,133.645288 230.40076,132.560229 C233.377219,130.787876 232.644615,119.987347 233.018427,113.467524 C233.030552,113.261876 231.244406,113.356582 229.46774,113.800347",
    id: "Fill-21",
    fill: "#BBC7D0",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.359844,
    y1: 116.461312,
    x2: 232.798177,
    y2: 115.795665,
    id: "Stroke-22",
    stroke: "#98AAB6",
    strokeWidth: 0.514,
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.229437,104.709529 C215.265375,105.004471 219.555375,106.927 219.999542,110.769353 C220.443708,114.613059 220.738917,118.456765 220.738917,118.456765 L214.229437,104.709529 Z",
    id: "Fill-23",
    fill: "#395C6E",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-24",
    fill: "#FFF4D0",
    mask: "url(#not_pet_mask-2)",
    points: "50.8076563 200.821929 123.533177 200.821929 123.533177 53.1199882 50.8076563 52.7195176"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.308,144.317424 C152.308,144.317424 150.99175,169.290012 160.201438,197.879012 L164.476542,198.863953 L165.55175,200.496953 C165.55175,200.496953 155.901958,203.296188 156.229667,205.596188 C156.560083,207.897541 172.700396,205.107776 172.700396,205.107776 C172.536542,202.209776 171.714563,199.438953 169.738833,196.892718 L173.357167,195.579012 L165.792792,169.620129 L171.713208,143.988659 L152.308,144.317424 Z",
    id: "Fill-25",
    fill: "#003449",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-26",
    fill: "#FBDE8B",
    mask: "url(#not_pet_mask-2)",
    points: "50.8076563 52.7197882 113.764219 64.6554353 113.764219 189.262671 50.8076563 200.8222"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-27",
    fill: "#98AAB6",
    mask: "url(#not_pet_mask-2)",
    points: "58.4050729 61.8858294 106.167885 70.9410647 106.167885 182.940241 58.4050729 191.710006"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-28",
    fill: "#FBDE8B",
    mask: "url(#not_pet_mask-2)",
    points: "107.055813 93.4354706 56.7241458 85.8454706 56.7241458 95.6488824 107.371333 102.290471"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-29",
    fill: "#FBDE8B",
    mask: "url(#not_pet_mask-2)",
    points: "107.055813 120.9501 56.7241458 118.4201 56.7241458 128.223512 107.371333 129.8051"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-30",
    fill: "#FBDE8B",
    mask: "url(#not_pet_mask-2)",
    points: "107.055813 151.310776 56.7241458 154.789188 56.7241458 164.593953 107.371333 160.165776"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31",
    fill: "#E2E6EC",
    mask: "url(#not_pet_mask-2)",
    points: "111.487323 121.582329 108.00576 121.267094 108.00576 133.442212 111.487323 133.283918"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.703292,134.1314 C147.703292,134.1314 131.367979,165.995871 130.708237,166.572224 C130.657042,166.616871 138.165896,197.879282 138.165896,197.879282 L141.455167,196.892988 L142.770063,200.179282 C143.359125,204.4884 133.992354,208.323988 135.53475,212.0094 C136.458292,214.216047 152.237042,205.374576 152.237042,205.374576 C152.151729,202.442753 151.39475,199.812635 148.361417,198.208047 L147.375583,194.921753 L150.005375,193.935459 C150.005375,193.935459 143.953604,176.157812 145.429646,168.715282 C146.905688,161.274106 162.833396,153.188929 164.806417,144.975224 C166.779438,136.760165 147.703292,134.1314 147.703292,134.1314",
    id: "Fill-42",
    fill: "#395C6E",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.703292,97.3285588 C147.798083,96.8306765 155.332667,90.3582059 158.556938,92.3984412 C159.858292,93.2034412 160.921313,95.4858529 161.846208,98.6422647 L147.703292,97.3285588 Z",
    id: "Fill-43",
    fill: "#BBC7D0",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.459219,144.293071 C172.062448,142.035012 169.087344,128.539424 168.09474,114.416071 C166.779844,95.6859529 160.110573,75.7246588 145.726615,99.2401294 C139.215781,109.882365 133.889844,117.569776 133.889844,117.569776 C133.889844,117.569776 101.85026,129.635306 117.910677,129.395835 C137.735677,129.099541 143.062969,117.569776 143.062969,117.569776 L139.481198,146.290012 C143.798281,148.534541 161.720677,151.157894 166.121719,149.574953 C169.225469,148.458776 170.92224,147.435953 171.833594,146.595776 C171.833594,146.595776 172.857344,146.551129 172.459219,144.293071",
    id: "Fill-44",
    fill: "#BBC7D0",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.756802,95.6921765 C150.756802,95.6921765 157.266281,96.8746471 157.56149,98.6497059 C157.56149,98.6497059 158.745031,123.186647 158.745031,124.960353 C158.745031,126.734059 159.338156,134.421471 164.665448,135.012706 C169.990031,135.603941 176.796073,132.647765 177.091281,130.577765 C177.387844,128.507765 177.387844,120.525412 177.387844,120.525412 L173.245448,116.978 C173.245448,116.978 170.583156,100.127118 166.735969,98.9446471 C162.888781,97.7621765 158.745031,95.6921765 158.745031,95.6921765 C158.745031,95.6921765 152.827323,93.9184706 150.756802,95.6921765",
    id: "Fill-45",
    fill: "#003449",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-46",
    fill: "#003449",
    mask: "url(#not_pet_mask-2)",
    points: "158.745573 126.439253 150.757344 122.004312 149.867656 124.665547 159.337344 128.212959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.953177,96.6711647 C153.953177,96.6711647 149.018594,94.0424 147.045573,99.2999294 C145.072552,104.557459 145.730677,120.987576 145.730677,120.987576 L144.920885,121.600459 C146.975156,123.964047 149.395052,125.870341 151.995052,127.552047 C154.47724,123.790871 156.286406,119.047459 156.582969,113.101282 C157.242448,99.9574588 153.953177,96.6711647 153.953177,96.6711647",
    id: "Fill-47",
    fill: "#E2E6EC",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.665813,129.099541 L111.104771,124.369659 L116.727271,125.257188 C116.727271,125.257188 114.655396,128.213365 117.910813,129.395835 C117.910813,129.395835 112.880083,130.8746 110.216437,128.8046 C110.216437,128.8046 107.257583,131.760776 106.665813,129.099541",
    id: "Fill-48",
    fill: "#C68053",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.256,98.3531412 L164.369021,95.9882 C164.369021,95.9882 170.877146,104.266847 170.286729,104.561788 C169.449854,104.979847 164.369021,102.491788 164.369021,101.605612 C164.369021,100.718082 165.256,98.3531412 165.256,98.3531412",
    id: "Fill-49",
    fill: "#003449",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.588073,
    y1: 195.618924,
    x2: 148.906198,
    y2: 191.405865,
    id: "Stroke-50",
    stroke: "#003449",
    strokeWidth: 0.791,
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.795479,149.055424 C149.795479,149.055424 135.592979,162.494188 138.255271,173.888659 C139.8085,180.541071 142.692875,193.402129 142.692875,193.402129",
    id: "Stroke-51",
    stroke: "#003449",
    strokeWidth: 0.791,
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.342958,
    y1: 149.942547,
    x2: 157.119625,
    y2: 155.707429,
    id: "Stroke-52",
    stroke: "#003449",
    strokeWidth: 0.791,
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.678135,122.287888 C156.33949,123.774771 156.977302,130.145771 154.426052,128.8713 C151.876156,127.596829 150.813135,130.145771 150.813135,130.145771 C146.77501,125.897535 139.123969,128.234065 139.123969,128.234065 C140.185635,106.785888 148.475844,96.8052412 148.475844,96.8052412 C155.490427,92.7707706 157.827719,106.9983 157.827719,106.9983 C157.827719,106.9983 161.016781,120.801006 158.678135,122.287888 M161.228031,117.616182 C159.527198,110.395535 158.889385,92.1335353 148.26324,95.5307706 C148.26324,95.5307706 143.373344,95.7431824 136.997927,122.5003 C131.849385,144.101359 143.585948,146.497418 143.585948,146.497418 C143.585948,146.497418 150.600531,150.319476 155.276469,148.620182 C159.952406,146.922241 169.091677,138.639535 170.579906,135.2423 C172.068135,131.843712 162.928865,124.836829 161.228031,117.616182",
    id: "Fill-53",
    fill: "#FDD058",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.875365,131.857647 L140.652552,140.415 C140.652552,140.415 140.040469,142.248235 142.284323,143.062706 C144.526823,143.878529 149.828385,144.897294 149.828385,144.897294 C149.828385,144.897294 152.276719,145.507471 152.276719,143.469941 C152.276719,141.433765 151.664635,133.895176 151.664635,133.895176 L141.875365,131.857647 Z",
    id: "Fill-54",
    fill: "#FBDE8B",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.875365,131.857647 L140.652552,140.415 C140.652552,140.415 140.040469,142.248235 142.284323,143.062706 C144.526823,143.878529 149.828385,144.897294 149.828385,144.897294 C149.828385,144.897294 152.276719,145.507471 152.276719,143.469941 C152.276719,141.433765 151.664635,133.895176 151.664635,133.895176 L141.875365,131.857647 Z",
    id: "Stroke-55",
    stroke: "#FDD058",
    strokeWidth: 0.681,
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.059479,129.412612 C141.059479,129.412612 139.836667,134.0992 142.079167,134.506435 C144.323021,134.913671 150.441146,136.9512 150.441146,136.9512 C150.441146,136.9512 153.09125,138.174259 152.683646,135.320906 L152.276042,132.468906 L141.059479,129.412612 Z",
    id: "Fill-56",
    fill: "#FBDE8B",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.059479,129.412612 C141.059479,129.412612 139.836667,134.0992 142.079167,134.506435 C144.323021,134.913671 150.441146,136.9512 150.441146,136.9512 C150.441146,136.9512 153.09125,138.174259 152.683646,135.320906 L152.276042,132.468906 L141.059479,129.412612 Z",
    id: "Stroke-57",
    stroke: "#FDD058",
    strokeWidth: 0.681,
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.189094,132.269212 L160.165552,139.276094 C160.165552,139.276094 161.227219,141.1878 162.715448,140.125741 C164.203677,139.063682 167.391385,135.454035 167.391385,135.454035 C167.391385,135.454035 169.304823,133.756094 168.030552,132.269212 C166.753573,130.782329 163.778469,127.597506 163.778469,127.597506 L157.189094,132.269212 Z",
    id: "Fill-58",
    fill: "#FBDE8B",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.189094,132.269212 L160.165552,139.276094 C160.165552,139.276094 161.227219,141.1878 162.715448,140.125741 C164.203677,139.063682 167.391385,135.454035 167.391385,135.454035 C167.391385,135.454035 169.304823,133.756094 168.030552,132.269212 C166.753573,130.782329 163.778469,127.597506 163.778469,127.597506 L157.189094,132.269212 Z",
    id: "Stroke-59",
    stroke: "#FDD058",
    strokeWidth: 0.681,
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.340167,131.206882 L156.764021,133.331 C156.764021,133.331 157.614438,135.028941 158.890063,134.180647 C160.165688,133.331 165.054229,129.933765 165.054229,129.933765 C165.054229,129.933765 166.753708,128.659294 165.266833,127.172412 L163.778604,125.685529 L156.340167,131.206882 Z",
    id: "Fill-60",
    fill: "#FBDE8B",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.340167,131.206882 L156.764021,133.331 C156.764021,133.331 157.614438,135.028941 158.890063,134.180647 C160.165688,133.331 165.054229,129.933765 165.054229,129.933765 C165.054229,129.933765 166.753708,128.659294 165.266833,127.172412 L163.778604,125.685529 L156.340167,131.206882 Z",
    id: "Stroke-61",
    stroke: "#FDD058",
    strokeWidth: 0.681,
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.627281,137.910165 C128.10051,137.1214 127.155302,136.470635 126.386135,135.662929 C125.197177,136.643812 120.487385,140.703988 121.062906,143.003988 C121.721031,145.632753 124.68124,144.975224 124.68124,144.975224 L129.285406,139.388929 L129.944885,139.591871 C129.418115,139.077753 128.94551,138.546047 128.627281,137.910165",
    id: "Fill-62",
    fill: "#C68053",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.921021,121.600865 L126.654667,135.445512 C126.654667,135.445512 126.555813,135.522629 126.385188,135.663335 C127.155708,136.471041 128.100917,137.121806 128.627688,137.910571 C128.945917,138.5451 129.418521,139.078159 129.943938,139.590924 L132.040188,140.629982 C132.040188,140.629982 145.259562,137.752276 151.995187,127.552453 C149.395187,125.869394 146.975292,123.964453 144.921021,121.600865",
    id: "Fill-63",
    fill: "#E2E6EC",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.509948,122.891029 C197.065781,123.778559 198.396927,124.666088 197.954115,125.552265 C196.900573,126.780735 195.918802,128.079559 195.168594,129.474441 C197.26349,127.250206 199.153906,124.950206 199.153906,124.950206 L199.143073,125.162618 C199.520885,123.257676 199.91901,121.373029 200.173594,119.343618 C199.729427,121.117324 198.841094,121.561088 197.509948,122.891029",
    id: "Fill-64",
    fill: "#98AAB6",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.264833,105.596112 C205.277854,97.6137588 198.924104,106.601347 198.924104,106.601347 C198.924104,106.601347 192.495875,116.787641 191.960979,118.308347 C191.427437,119.830406 185.291708,125.821229 185.748063,129.3957 C186.203062,132.968818 191.942021,132.740171 193.959729,130.725641 C194.361917,130.322465 194.769521,129.900347 195.169,129.474171 C195.919208,128.080641 196.899625,126.780465 197.954521,125.551994 C198.397333,124.665818 197.066188,123.778288 197.510354,122.890759 C198.8415,121.560818 199.728479,121.117053 200.172646,119.343347 C199.919417,121.372759 199.521292,123.257406 199.143479,125.162347 L197.399313,156.9267 C197.399313,156.9267 206.386917,160.695994 209.050563,156.704818 C211.714208,152.713641 214.598583,153.268347 214.820667,154.377759 C215.04275,155.485818 225.434625,159.575759 228.580354,157.925171 C228.580354,157.925171 221.457438,110.546524 215.264833,105.596112",
    id: "Fill-65",
    fill: "#BBC7D0",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.265188,127.104494 C214.265188,125.725847 214.247583,124.443259 214.217792,123.232376 C212.706542,123.068671 211.195292,122.803494 209.684042,122.554553 C209.768,124.146965 209.850604,125.882788 209.9305,127.698435 C211.369979,127.771494 212.825708,127.916259 214.26925,128.081318 C214.267896,127.755259 214.265188,127.433259 214.265188,127.104494",
    id: "Fill-66",
    fill: "#395C6E",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.930229,127.6983 C210.108979,131.785535 210.263354,136.285418 210.321583,140.512006 C211.751583,140.728476 213.187,140.915182 214.63325,141.058594 C214.434188,137.246006 214.287937,132.838124 214.268979,128.081182 C212.825438,127.916124 211.369708,127.771359 209.930229,127.6983",
    id: "Fill-67",
    fill: "#FFFCF3",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.288896,115.564176 C209.38775,117.159294 209.534,119.617588 209.684312,122.554824 C211.195562,122.803765 212.705458,123.067588 214.218062,123.232647 C214.147646,120.465882 214.008167,118.114471 213.832125,116.144588 C212.318167,115.987647 210.802854,115.750882 209.288896,115.564176",
    id: "Fill-68",
    fill: "#FFFCF3",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.26799,109.719741 C208.779865,111.8398 209.16174,113.578329 209.16174,113.578329 C209.16174,113.578329 209.21049,114.304859 209.289031,115.564447 C210.80299,115.751153 212.318302,115.987918 213.83226,116.144859 C213.610177,113.648682 213.333927,111.749153 213.073927,110.358329 C211.478719,110.177035 209.865906,109.906447 208.26799,109.719741",
    id: "Fill-69",
    fill: "#395C6E",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.469167,106.549394 C207.746771,107.593865 208.023021,108.700571 208.268125,109.719335 C209.866042,109.906041 211.478854,110.177982 213.074063,110.357924 C212.646146,108.072806 212.268333,107.148747 212.268333,107.148747 C212.268333,107.148747 212.124792,106.872747 211.870208,106.477688 C210.409063,106.535865 208.946563,106.596747 207.469167,106.549394",
    id: "Fill-70",
    fill: "#FFFCF3",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.162094,103.490124 C207.131573,103.391359 206.645427,103.229006 206.42199,103.077476 C206.732094,103.900065 207.103135,105.171829 207.46876,106.549124 C208.946156,106.596476 210.408656,106.535594 211.869802,106.477418 C211.22251,105.465418 209.837198,103.649771 208.162094,103.490124",
    id: "Fill-71",
    fill: "#395C6E",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.421854,103.077206 C206.37175,102.945971 206.323,102.8215 206.276958,102.713265 C206.276958,102.713265 206.138833,102.886441 206.421854,103.077206",
    id: "Fill-72",
    fill: "#395C6E",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.477156,157.577329 C204.197365,159.369976 198.841635,157.481271 198.841635,157.481271 C198.841635,157.481271 192.279344,179.325859 196.400073,193.401859 L199.063719,194.509918 C199.063719,194.509918 202.014448,195.175565 203.764031,195.175565 C202.339448,182.365918 202.821531,169.456153 207.477156,157.577329",
    id: "Fill-73",
    fill: "#F1BB9A",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.516365,195.1757 L197.422198,196.508347 C197.422198,196.508347 198.611156,202.131171 196.051781,202.856347 C193.489698,203.582876 190.39949,206.380759 192.169385,206.618876 C196.287406,207.176288 202.16449,204.793759 204.939177,203.519288 C204.47199,200.751171 204.073865,197.965465 203.76376,195.1757 L198.516365,195.1757 Z",
    id: "Fill-74",
    fill: "#99B7C5",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.069865,189.860265 C238.398198,186.095029 236.425177,176.383618 231.75601,169.256324 C226.022469,160.506853 228.097052,158.244735 228.097052,158.244735 C223.697365,158.367853 215.929865,155.486088 215.707781,154.376676 C215.562885,153.646088 214.732781,141.147618 214.321115,133.257265 C212.874865,133.1125 211.565385,133.238324 210.15976,133.534618 C210.251844,140.2425 210.132677,150.867147 209.448823,154.782559 C210.29924,156.173382 211.825385,156.889088 212.912781,158.041794 C212.957469,158.003912 212.999448,157.961971 213.044135,157.925441 C213.044135,157.925441 225.39549,177.371265 231.834552,190.444735 C234.319448,190.816794 236.85851,190.746441 239.069865,189.860265",
    id: "Fill-75",
    fill: "#F1BB9A",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.528792,195.3229 C239.528792,195.3229 239.494937,191.813371 239.340562,190.955606 C237.666812,191.626665 235.804833,191.828253 233.919833,191.726782 C233.126292,191.684841 232.572437,192.491194 232.912333,193.209606 C232.915042,193.213665 232.91775,193.220429 232.920458,193.225841 C233.584,194.626135 231.846604,196.775959 228.222854,200.288194 C224.599104,203.800429 234.764833,206.716018 237.674937,199.880959 C240.583687,193.0459 239.528792,195.3229 239.528792,195.3229",
    id: "Fill-76",
    fill: "#99B7C5",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.939313,203.519829 C205.912958,203.072006 206.507438,202.760829 206.507438,202.760829 C206.507438,202.760829 206.166188,199.712653 205.940042,195.176241 L203.763896,195.176241 C204.072646,197.966006 204.472125,200.750359 204.939313,203.519829",
    id: "Fill-77",
    fill: "#75A2B2",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.91224,158.041794 C211.824844,156.889088 210.298698,156.173382 209.448281,154.782559 C209.331823,155.448206 209.201823,155.925794 209.050156,156.151735 C208.631719,156.7795 208.090052,157.242206 207.476615,157.577735 C202.822344,169.456559 202.338906,182.366324 203.76349,195.175971 L205.94099,195.175971 C205.393906,184.165735 205.533385,164.380324 212.91224,158.041794",
    id: "Fill-78",
    fill: "#EEA37A",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.617625,115.426041 C201.282521,114.982276 203.279917,113.652335 203.279917,113.652335 C203.279917,113.652335 204.833146,116.535453 202.837104,117.643512 C200.838354,118.751571 200.617625,115.426041 200.617625,115.426041",
    id: "Fill-79",
    fill: "#F7D5BE",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.041177,106.594312 L214.154823,109.8089 L216.596385,111.6949 C216.596385,111.6949 218.926906,123.112371 214.487948,124.887429",
    id: "Stroke-80",
    stroke: "#98AAB6",
    strokeWidth: 0.514,
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-81",
    stroke: "#98AAB6",
    strokeWidth: 0.514,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#not_pet_mask-2)",
    points: "218.926635 136.084235 224.585698 136.971765 226.027885 148.834353 219.924656 148.057765"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.057344,108.146135 L206.72099,110.585488 L205.166406,112.581076 C205.166406,112.581076 205.943698,122.890488 209.605365,124.665547",
    id: "Stroke-82",
    stroke: "#98AAB6",
    strokeWidth: 0.514,
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.69701,93.6627647 C211.69701,93.6627647 214.827844,98.8742941 213.973365,101.432706 C213.12024,103.991118 211.412635,103.328176 212.456698,104.938176 C213.499406,106.549529 212.101906,106.843118 212.101906,106.843118 C212.101906,106.843118 210.382115,104.027647 209.244615,103.932941 C208.107115,103.838235 208.093573,96.9788235 211.69701,93.6627647",
    id: "Fill-83",
    fill: "#C68053",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.895833,88.7358941 C210.273646,89.1147176 214.265729,88.6344235 214.265729,88.6344235 C214.265729,88.6344235 215.775625,93.4725412 214.827708,95.9376 C213.878437,98.4013059 212.740937,101.337188 211.222917,101.337188 C209.704896,101.337188 209.136146,100.579541 209.325729,103.802247 C209.325729,103.802247 213.499271,107.497129 210.654167,107.686541 C207.809062,107.875953 205.343125,100.674247 205.343125,100.106012 C205.343125,99.5377765 207.429896,88.5464824 207.429896,88.5464824 L209.895833,88.7358941 Z",
    id: "Fill-84",
    fill: "#F7D5BE",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.719146,135.751953 C207.127375,135.751953 199.433,137.229365 199.433,137.229365 L199.137792,148.907953 L207.422583,148.760482 L207.719146,135.751953 Z",
    id: "Stroke-85",
    stroke: "#98AAB6",
    strokeWidth: 0.514,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.923698,106.601618 C198.923698,106.601618 202.393073,111.9525 201.947552,116.091147 C201.50474,120.231147 197.954115,128.655912 198.103073,131.020853 L198.545885,133.534618 L201.653698,123.334794 C201.653698,123.334794 205.79474,114.464912 204.168385,107.517559 L198.923698,106.601618 Z",
    id: "Fill-86",
    fill: "#395C6E",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.101167,81.2623824 C203.377417,82.2026765 202.800542,83.1795 201.813354,83.4419706 C200.824813,83.7057941 199.799708,83.1565 199.522104,82.2162059 C199.245854,81.2745588 199.824083,80.2990882 200.812625,80.0352647 C201.799813,79.7714412 202.824917,80.3220882 203.101167,81.2623824",
    id: "Fill-87",
    fill: "#EEA37A",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.02024,111.804624 C205.764406,112.684035 204.793469,114.917741 202.836698,117.643918 L197.287323,123.630682 L195.069198,120.525682 L197.287323,118.235153 C197.287323,118.235153 197.287323,113.800212 198.619823,112.914035 C199.950969,112.026506 202.46701,111.582741 204.02024,111.804624",
    id: "Fill-88",
    fill: "#F7D5BE",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.093302,88.4512353 C208.093302,88.4512353 209.70476,94.0415882 206.86101,95.7476471 C204.014552,97.4537059 208.377677,100.485647 208.188094,102.379765 C208.102781,103.238882 207.391844,103.631235 206.712052,104.066882 C205.892781,104.594529 205.118198,105.185765 205.532573,106.738941 C206.290906,109.581471 203.73424,110.924941 202.687469,110.339118 C197.945177,107.686 197.281635,105.046412 198.987885,102.102412 C200.69549,99.1584118 197.33174,98.1166471 199.677156,94.4217647 C202.023927,90.7255294 202.78226,91.1043529 204.233927,86.4827059 L208.093302,88.4512353 Z",
    id: "Fill-89",
    fill: "#C68053",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.50501,92.9578824 C201.50501,92.9578824 200.567927,93.8738235 200.033031,92.6358824 C199.49949,91.3979412 199.305844,89.0938824 199.305844,89.0938824 C199.305844,89.0938824 199.579385,87.7382353 206.251365,85.6952941 C212.924698,83.6523529 214.106885,85.9564118 214.274802,86.411 C214.442719,86.8669412 214.77449,88.5215882 214.483344,89.1750588 C214.192198,89.8285294 211.785844,86.7302941 201.50501,92.9578824",
    id: "Fill-90",
    fill: "#FDD058",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.941896,89.5095059 C199.941896,89.5095059 199.324396,87.5504471 200.256062,86.8158 C199.584396,86.1555647 200.051583,81.7003294 202.058458,82.2036235 C205.862312,83.1588 207.931479,80.9656824 210.092729,83.1358 C212.917521,85.9742706 213.307521,85.9593882 213.307521,85.9593882 L199.941896,89.5095059 Z",
    id: "Fill-91",
    fill: "#FDD058",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.256604,86.8155294 C200.256604,86.8155294 202.72525,86.6382941 204.168792,84.9755294",
    id: "Stroke-92",
    stroke: "#EEA37A",
    strokeWidth: 0.514,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.506802,88.5232118 C199.506802,88.5232118 205.27826,84.7539176 212.157427,84.9758",
    id: "Stroke-93",
    stroke: "#EEA37A",
    strokeWidth: 0.514,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.80624,113.874353 C198.249052,113.430588 200.765094,110.179471 200.765094,110.179471 C200.765094,110.179471 201.653427,110.770706 200.469885,113.430588 C199.286344,116.091824 197.80624,113.874353 197.80624,113.874353",
    id: "Fill-94",
    fill: "#F7D5BE",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.142344,157.481541 C224.142344,157.481541 231.140677,168.802953 239.069323,189.860129",
    id: "Stroke-95",
    stroke: "#EEA37A",
    strokeWidth: 0.741,
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.141479,187.990771 C249.535542,186.7393 249.968875,185.218594 250.440125,183.503065 C248.427833,182.750829 246.500854,181.461476 244.596896,180.2763 L244.881271,180.541476 L244.420854,182.719712 C243.227833,184.864124 247.171167,187.283182 249.141479,187.990771",
    id: "Fill-96",
    fill: "#98AAB6",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.114948,182.758676 C244.114948,182.509735 243.69651,182.678853 243.252344,182.719441 L242.783802,184.3105 C242.783802,184.3105 235.459115,181.650618 234.794219,182.314912 C234.127969,182.980559 243.894219,192.070971 247.444844,191.627206 C248.052865,191.551441 248.843698,190.189029 249.805156,187.9905 C247.071094,187.282912 245.172552,186.277676 244.114948,182.758676",
    id: "Fill-97",
    fill: "#003449",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.18549,144.620753 C255.487781,139.969341 255.150594,162.1684 253.191115,179.3034 C258.099969,166.209635 265.294656,147.344224 274.102156,147.066871 C275.024344,145.786988 275.873406,144.8494 275.18549,144.620753",
    id: "Fill-98",
    fill: "#FDD058",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.830906,190.962912 L290.721844,147.059971 L255.655698,133.978382 C255.655698,133.978382 241.89601,159.0335 241.231115,178.7675 L243.496635,180.276029 C246.139969,181.461206 248.754865,183.447324 251.549865,184.199559 C252.046844,182.898029 252.634552,180.788794 253.191115,179.303265 C255.150594,162.168265 255.487781,139.969206 275.18549,144.620618 C275.873406,144.850618 275.024344,145.786853 274.102156,147.066735 C274.167156,147.065382 274.23351,147.059971 274.29851,147.059971 C274.29851,147.059971 271.856948,178.7675 278.293302,192.9585 L280.06726,192.736618 L291.830906,190.962912 Z",
    id: "Fill-99",
    fill: "#FBDE8B",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.280146,194.384229 L288.058062,191.295465 C285.755979,191.327935 283.533792,191.866406 281.288583,192.072053 L281.288583,193.442582 C283.555458,192.5767 285.976708,194.926759 288.280146,194.384229",
    id: "Fill-100",
    fill: "#98AAB6",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.1565,193.442853 L280.290563,194.510324 C280.290563,194.510324 273.187958,196.062147 274.298375,198.723382 C274.298375,198.723382 283.620458,199.831441 289.833375,197.613971 L289.429833,194.3845 C286.374833,194.927029 283.164104,192.576971 280.1565,193.442853",
    id: "Fill-101",
    fill: "#003449",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.285083,92.9578824 C283.843625,92.8104118 282.331021,91.3005294 281.360083,90.298 C278.250917,93.3637647 274.252063,95.4067059 269.8605,96.2834118 C268.528,96.2834118 267.639667,98.0584706 266.752687,98.5008824 C265.107375,98.9703529 263.337479,97.3265294 262.497896,95.3471765 C259.354875,103.261882 251.110708,129.329 250.551437,137.525118 C249.886542,147.281176 290.277271,147.946824 290.721437,147.059294 C291.16425,146.173118 297.364979,97.3143529 284.285083,92.9578824",
    id: "Fill-102",
    fill: "#EEA37A",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.528406,89.9646353 C268.195281,89.6318118 264.533615,90.7398706 263.056219,94.0153412 C262.895073,94.3711647 262.708198,94.8189882 262.498302,95.3466353 C263.337885,97.3259882 265.107781,98.9711647 266.75174,98.5016941 C267.640073,98.0579294 268.528406,96.2828706 269.859552,96.2828706 C269.938094,96.2679882 270.016635,96.2490471 270.093823,96.2328118 C270.403927,94.6904588 270.672052,93.1007529 271.190698,91.6598706 C270.543406,91.2120471 269.72549,90.5896941 268.528406,89.9646353",
    id: "Fill-103",
    fill: "#E7824F",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.301469,95.2858882 C271.301469,95.2858882 266.974906,97.8361824 266.974906,107.592241 C266.974906,107.592241 261.425531,115.130829 261.869698,120.230065 C261.869698,120.230065 257.654177,125.552535 258.983969,131.983065 C258.983969,131.983065 255.655427,140.851594 258.541156,144.177124 C258.541156,144.177124 254.324281,142.6253 253.437302,141.515888 C253.437302,141.515888 258.319073,112.027182 265.420323,98.2785941 C265.420323,98.2785941 266.641781,94.8421235 268.306052,94.0668882 C268.306052,94.0668882 267.339177,95.1749471 271.41251,95.1749471 C271.523552,95.1749471 271.301469,95.2858882 271.301469,95.2858882",
    id: "Fill-104",
    fill: "#6799AA",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.9745,107.591835 C268.083562,107.591835 278.292625,109.143659 278.292625,109.143659",
    id: "Stroke-105",
    stroke: "#E7824F",
    strokeWidth: 0.791,
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.64775,120.008724 C262.756812,120.008724 280.512646,122.226194 280.512646,122.226194",
    id: "Stroke-106",
    stroke: "#E7824F",
    strokeWidth: 0.791,
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.76351,131.982388 C259.872573,131.982388 281.179031,135.086035 281.179031,135.086035",
    id: "Stroke-107",
    stroke: "#E7824F",
    strokeWidth: 0.791,
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.958333,74.3324824 C276.164688,74.5191882 270.241562,72.2056588 267.362604,73.4260118 C270.05875,76.6067765 274.7875,72.8253059 276.960938,74.9981294 C277.849271,75.4405412 276.960938,77.6580118 275.185625,78.5455412 C274.298646,78.9879529 273.410313,81.2067765 274.298646,81.6491882 C276.516771,83.4228941 276.960938,77.6580118 278.73625,79.8754824 C280.957083,81.6491882 278.73625,83.8666588 278.73625,86.0841294 C278.858125,86.6916 279.150625,87.2977176 279.569063,87.8781294 C279.713958,87.7008941 279.876458,87.5426 280.067396,87.4140706 C280.255625,87.1651294 279.361875,87.7983059 279.624583,87.6359529 C282.066146,77.4361294 281.416146,74.1687765 278.958333,74.3324824",
    id: "Fill-108",
    fill: "#BBC7D0",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.074313,90.4078588 C275.835354,89.6488588 278.719729,88.9182706 279.568792,87.8778588 C279.150354,87.2974471 278.857854,86.6913294 278.735979,86.0838588 C278.735979,83.8663882 280.956813,81.6489176 278.735979,79.8752118 C276.962021,77.6577412 276.5165,83.4226235 274.298375,81.6489176 C273.410042,81.2065059 274.298375,78.9890353 275.185354,78.5452706 C276.962021,77.6577412 277.849,75.4402706 276.962021,74.9978588 C274.787229,72.8250353 270.058479,76.6065059 267.363688,73.4257412 C266.812542,73.6598 266.371083,74.7962706 266.086708,75.3293294 C265.572125,76.2926235 266.479417,77.9621529 265.420458,79.4328 C263.423063,82.2036235 264.515875,88.9980941 265.864625,90.1859765 C267.753688,91.8500941 268.669104,94.0946235 268.306188,94.6209176 C272.181813,96.6462706 272.222438,94.3259765 275.074313,90.4078588",
    id: "Fill-109",
    fill: "#C68053",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.363281,73.4261471 C267.363281,73.4261471 266.752552,69.3429706 268.416823,69.7867353 C270.081094,70.2305 270.414219,71.5604412 271.967448,71.0057353 C273.522031,70.4523824 273.077865,71.4508529 274.075885,71.6713824 C275.073906,71.8932647 275.518073,70.7852059 276.739531,71.5604412 C277.959635,72.3370294 280.068073,75.2187941 280.068073,75.2187941",
    id: "Fill-110",
    fill: "#BBC7D0",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.067802,87.4146118 C279.87551,87.5431412 272.744469,90.2963765 271.189885,91.6601412 C268.860719,93.8437882 269.415927,95.2860235 270.094365,96.2330824 C274.393844,95.3306706 278.306031,93.3093765 281.359677,90.2977294 C281.925719,89.5482 281.026552,86.9884353 280.067802,87.4146118",
    id: "Fill-111",
    fill: "#E7824F",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.700719,99.5356118 C277.700719,99.5356118 273.853531,109.291671 277.108948,116.387847 C280.364365,123.482671 277.40551,147.133435 277.40551,147.133435 L290.721031,147.059024 C290.721031,147.059024 300.189365,113.726612 286.282073,103.674259 L277.700719,99.5356118 Z",
    id: "Fill-112",
    fill: "#E98C5C",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.054781,143.734171 C290.054781,143.734171 301.59499,120.674641 286.061344,97.6137588 C286.061344,97.6137588 282.620406,94.8429353 278.736656,97.6137588 C276.717594,99.0546412 275.630198,104.930465 277.183427,109.587288 C278.736656,114.244112 285.17301,123.334524 285.17301,123.334524 C285.17301,123.334524 282.671865,137.701406 281.507281,143.432465 C283.374677,143.589406 285.201448,143.850524 287.056656,144.108935 L290.054781,143.734171 Z",
    id: "Fill-113",
    fill: "#6799AA",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 241.452927,
    y1: 175.4417,
    x2: 252.326885,
    y2: 181.206582,
    id: "Stroke-114",
    stroke: "#FDD058",
    strokeWidth: 0.741,
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 277.29474,
    y1: 190.075653,
    x2: 291.49724,
    y2: 188.412888,
    id: "Stroke-115",
    stroke: "#FDD058",
    strokeWidth: 0.741,
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 286.72624,
    y1: 146.616476,
    x2: 288.945719,
    y2: 188.745712,
    id: "Stroke-116",
    stroke: "#FDD058",
    strokeWidth: 0.741,
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.017021,158.983171 L287.490667,147.380347 L285.995667,148.227288 L291.387958,159.627171 C291.387958,159.627171 291.641188,160.118288 289.910563,160.829935 C288.178583,161.541582 288.381708,163.169171 288.381708,163.169171 C288.381708,163.169171 299.317958,188.297347 301.146083,191.479465 C303.434625,195.465229 305.88025,194.280053 305.88025,194.280053 C305.88025,194.280053 308.000875,193.242347 310.311083,192.028759 L294.321083,158.267465 C293.526188,158.658465 293.017021,158.983171 293.017021,158.983171",
    id: "Fill-117",
    fill: "#003449",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.764177,184.619647 C315.764177,184.619647 305.203031,160.278882 301.997719,157.784059 C300.556885,156.663824 298.59876,156.792353 296.880323,157.274 L312.808031,190.675412 C313.183135,190.465706 313.543344,190.260059 313.876469,190.061176 C316.882719,188.283412 315.764177,184.619647 315.764177,184.619647",
    id: "Fill-118",
    fill: "#003449",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.320948,158.267735 L310.310948,192.029029 C311.151885,191.586618 312.011781,191.123912 312.808031,190.676088 L296.880323,157.273324 C295.903969,157.546618 295.006156,157.930853 294.320948,158.267735",
    id: "Fill-119",
    fill: "#BBC7D0",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.939833,194.424547 C305.572854,196.251018 303.793479,197.433488 301.965354,197.068194 C300.138583,196.701547 298.955042,194.923782 299.320667,193.098665 C299.687646,191.272194 301.465667,190.088371 303.293792,190.455018 C305.121917,190.820312 306.306812,192.598076 305.939833,194.424547",
    id: "Fill-120",
    fill: "#395C6E",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.507958,143.432871 C281.470042,143.616871 281.433479,143.7914 281.399625,143.955106 C280.290562,149.277576 283.620458,152.381224 283.620458,152.381224 C283.620458,152.381224 287.835979,152.159341 288.280146,149.498106 C288.722958,146.838224 286.503479,144.176988 286.503479,144.176988 L287.057333,144.109341 C285.202125,143.850929 283.375354,143.588459 281.507958,143.432871",
    id: "Fill-121",
    fill: "#C68053",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 201.17175,
    y1: 87.6359529,
    x2: 202.280813,
    y2: 92.5133059,
    id: "Stroke-122",
    stroke: "#EEA37A",
    strokeWidth: 0.514,
    strokeLinecap: "round",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.38925,
    y1: 86.3061471,
    x2: 205.277583,
    y2: 90.8506765,
    id: "Stroke-123",
    stroke: "#EEA37A",
    strokeWidth: 0.514,
    strokeLinecap: "round",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 207.607969,
    y1: 85.5299647,
    x2: 208.161823,
    y2: 89.6320824,
    id: "Stroke-124",
    stroke: "#EEA37A",
    strokeWidth: 0.514,
    strokeLinecap: "round",
    mask: "url(#not_pet_mask-2)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.047688,
    y1: 84.8647235,
    x2: 211.823625,
    y2: 88.9668412,
    id: "Stroke-125",
    stroke: "#EEA37A",
    strokeWidth: 0.514,
    strokeLinecap: "round",
    mask: "url(#not_pet_mask-2)"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgModifyTripWithNoPet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/modify-trip-with-no-pet.ade4bf81.svg";
export { ForwardRef as ReactComponent };